import React from "react";
import Reflux from "reflux";
import { Layout, Menu } from "antd";
import brandLogo from "@/assets/brand-logo@2x.png";
import GUtils from "@/utils";
import classNames from "classnames";

import { createAction } from "./Action";
import Store from "./Store";
import UserAccountMenu from "./UserAccountMenu";
import { buildMenuItems } from "./biz/buildMenuItems";
import { getMenuSelection } from "./menuSelection";
import { isLoginPath } from "../login/publicLayout";
import "./style.less";

const { Header, Content, Sider } = Layout;

export default class HomePage extends Reflux.Component {
  constructor(props) {
    super(props);
    this.action = createAction();
    this.store = new Store(props, this.action);
  }

  componentDidMount() {
    let path = (this.props.location && this.props.location.pathname) || window.location.pathname;
    this.syncModalLayout();
    // 先注册登录成功监听器：未登录直接访问 /page 页面时，
    // 跳转登录后也必须能加载菜单；重复注册前先移除旧监听，避免重复触发。
    if (this.__loginSuccessHandler) {
      GUtils.off(window, "login-success", this.__loginSuccessHandler);
    }
    this.__loginSuccessHandler = GUtils.on(window, "login-success", () => {
      this.setState({ user: window.user });
      this.action.getMenus();
    });
    if (this.__menuConfigChangedHandler) {
      GUtils.off(window, "menu-config-changed", this.__menuConfigChangedHandler);
    }
    this.__menuConfigChangedHandler = GUtils.on(window, "menu-config-changed", () => {
      this.action.getMenus();
    });
    if (path.startsWith("/page")) {
      //在内部页面了
      let user = JSON.parse(localStorage.getItem("user"));
      if (!user) {
        window.RouterGo(window.CONFIG.PAGE_LOGIN);
        return;
      }
      GUtils.initUserInfo(user);
      this.action.getMenus();
      this.setState({ user });
      // 检查是否在菜单列表中
    } else if (isLoginPath(path)) {
    } else {
      window.RouterGo("/403");
    }
  }

  componentDidUpdate() {
    this.syncModalLayout();

    const path = (this.props.location && this.props.location.pathname) || window.location.pathname;
    const previousPath =
      (this._previousLocation && this._previousLocation.pathname) || path;
    const menus = this.state.menus || [];
    const menusChanged = this._previousMenus !== menus;
    if (path !== previousPath && this.state.pendingSelectedKey) {
      this.setState({ pendingSelectedKey: null });
    }
    if (path !== previousPath || menusChanged) {
      const nextOpenKeys = getMenuSelection(path, menus).openKeys;
      const currentOpenKeys = this.state.openKeys || [];
      if (nextOpenKeys.join("|") !== currentOpenKeys.join("|")) {
        this.setState({ openKeys: nextOpenKeys });
      }
    }
    this._previousLocation = this.props.location;
    this._previousMenus = menus;
  }

  componentWillUnmount() {
    if (this.__loginSuccessHandler) {
      GUtils.off(window, "login-success", this.__loginSuccessHandler);
      this.__loginSuccessHandler = null;
    }
    if (this.__menuConfigChangedHandler) {
      GUtils.off(window, "menu-config-changed", this.__menuConfigChangedHandler);
      this.__menuConfigChangedHandler = null;
    }
    document.documentElement.style.removeProperty("--admin-sider-width");
  }

  syncModalLayout() {
    const isPage = window.location.pathname.startsWith("/page");
    const siderWidth = isPage ? (this.state.collapsed ? 80 : 200) : 0;
    document.documentElement.style.setProperty(
      "--admin-sider-width",
      `${siderWidth}px`
    );
  }

  handleCollapse(collapsed) {
    this.setState({ collapsed });
  }

  handleMenuChange({ key }) {
    this.setState({ pendingSelectedKey: key });
  }
  handleOpenChange(openKeys) {
    this.setState({ openKeys });
  }
  render() {
    let path = (this.props.location && this.props.location.pathname) || window.location.pathname;
    let isPage = path.startsWith("/page");
    return isPage ? this.renderMenuPage() : this.renderSimpleView();
  }

  // 基本页面
  renderSimpleView() {
    let { children } = this.props;
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content>{children}</Content>
      </Layout>
    );
  }

  handleLogout() {
    GUtils.confirm("退出", "确认退出系统?", this.action.logout);
  }
  renderMenuPage() {
    let { collapsed, menus = [], user = {}, pendingSelectedKey } = this.state;
    let { children } = this.props;
    let { userName, scope } = user;
    let path = (this.props.location && this.props.location.pathname) || window.location.pathname;
    const { selectedKeys, openKeys: routeOpenKeys } = getMenuSelection(path, menus);
    const openKeys = this.state.openKeys === undefined ? routeOpenKeys : this.state.openKeys;
    //window.RouteHistory = this.context.router.history
    return (
      <Layout style={{ minHeight: "100vh" }} className="layout">
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={this.handleCollapse.bind(this)}
        >
          <div
            className="brand"
            data-testid="brand-home"
            title="返回首页"
            style={{ cursor: "pointer" }}
            onClick={() => window.RouterGo(window.CONFIG.PAGE_HOME)}
          >
            <img className="brand__logo" src={brandLogo} alt="XLEME" />
          </div>
          <Menu
            theme="dark"
            selectedKeys={pendingSelectedKey ? [pendingSelectedKey] : selectedKeys}
            openKeys={openKeys}
            mode="inline"
            onClick={this.handleMenuChange.bind(this)}
            onOpenChange={this.handleOpenChange.bind(this)}
            items={buildMenuItems(menus)}
          />
        </Sider>
        <Layout>
          <Header>
            <div className="header-brand">洗了么运营管理后台</div>
            <UserAccountMenu
              userName={userName}
              scopeName={window.ENUMS.Scope[scope]}
              resetPasswordPath={window.CONFIG.PAGE_PERSONAL_RESETPWD}
              onLogout={this.handleLogout.bind(this)}
            />
          </Header>
          <Content
            className={classNames(
              "layout-content",
              path.includes("/product/coupon/addCoupon") &&
                "coupon-form-layout-content",
              path.includes("/ops/dashboard") &&
                "ops-dashboard-layout-content"
            )}
          >
            {menus && children}
          </Content>
        </Layout>
      </Layout>
    );
  }
}
